import React, { useState } from 'react';
import { 
  Modal, 
  Stack, 
  Autocomplete, 
  Group, 
  ActionIcon,
  Text
} from '@mantine/core';
import { IconX, IconPlus, IconSearch } from '@tabler/icons-react';

interface Collection {
  id: string;
  name: string;
}

interface CollectionModalProps {
  opened: boolean;
  onClose: () => void;
  onAdd: (collectionName: string) => void;
  collections: Collection[];
}

export const CollectionModal: React.FC<CollectionModalProps> = ({
  opened,
  onClose,
  onAdd,
  collections
}) => {
  const [collectionName, setCollectionName] = useState('');

  const handleAdd = () => {
    if (collectionName.trim()) {
      onAdd(collectionName);
      setCollectionName('');
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Add to Collection"
      styles={{
        header: { backgroundColor: '#f8f9fa' },
        title: { fontWeight: 600 }
      }}
    >
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          Add this image to an existing collection or create a new one.
        </Text>
        <Autocomplete
          label="Search for a collection or create a new one"
          placeholder="Type collection name..."
          data={collections.map(c => c.name)}
          value={collectionName}
          onChange={setCollectionName}
          leftSection={<IconSearch size={16} />}
        />
        <Group gap="xs" justify="flex-end">
          <ActionIcon 
            size="md" 
            variant="light" 
            color="gray"
            onClick={onClose}
          >
            <IconX size={16} />
          </ActionIcon>
          <ActionIcon 
            size="md" 
            variant="filled" 
            color="blue"
            onClick={handleAdd}
          >
            <IconPlus size={16} />
          </ActionIcon>
        </Group>
      </Stack>
    </Modal>
  );
};
